import React from 'react'

import { useNavigate } from 'react-router-dom'
import { UrlProvider } from 'urls'

import { ConfirmModal } from 'components/_base'
import { useAddNotification } from 'hooks/useAddNotification'
import { useDeleteUser } from 'hooks/useDeleteUser'

type UserDeleteConfirmProps = {
  id: any
  open: boolean
  onClose: (...args: any[]) => any
}

const UserDeleteConfirm = ({ id, open, onClose }: UserDeleteConfirmProps) => {
  const { mutate: deleteUser } = useDeleteUser()
  const addNotification = useAddNotification()
  const navigate = useNavigate()

  const handleDelete = () => {
    deleteUser(id, {
      onSuccess: () => {
        addNotification('User deleted successfully', 'success')
        navigate(UrlProvider.getUrl('users'))
      },
      onError: () => {
        onClose()
        addNotification('Error occurred when deleting user', 'error')
      },
    })
  }

  return <ConfirmModal onClose={onClose} onConfirm={handleDelete} open={open} title="Do you want to remove user?" />
}

export default UserDeleteConfirm
